
import { getApiBaseUrl, getApiClient } from "./serviceconfig";
import { appendQueryParams } from "../utils/listViewDateRanges";

var apiBaseUrl = getApiBaseUrl();

export async function getAllEquipments(cookies, searchStringOrParams) {

  let url= `${apiBaseUrl}/equipments/`;
  if (typeof searchStringOrParams === 'string' && searchStringOrParams) {
    url = url + `?name=${searchStringOrParams}`;
  } else if (searchStringOrParams && typeof searchStringOrParams === 'object') {
    url = appendQueryParams(url, searchStringOrParams);
  }
    return getApiClient(cookies).get(url)
      .then(response => response.data);
}

export async function createEquipments(cookies, inputs) {

  return getApiClient(cookies).post(`${apiBaseUrl}/equipments/`,inputs)
  
}

export async function updateEquipments(cookies, inputs, equipment_id) {

    return getApiClient(cookies)
    .put(`${apiBaseUrl}/equipments/${equipment_id}/`,inputs)
}
  


export async function getEquipmentsDetails(cookies, equipment_id) {

  return getApiClient(cookies).get(`${apiBaseUrl}/equipments/${equipment_id}/`)
  .then(response => response.data)
}

export async function deleteEquipments(cookies, equipment_id) {

  return getApiClient(cookies).delete(
    `${apiBaseUrl}/equipments/${equipment_id}/`)
   
}
